/**
 * The form inputs are given descriptive autocomplete hints ("zip code",
 * "superintendent first name", "staff"); browsers only understand the HTML
 * autofill tokens. This maps a hint to its token, or "off" when there is none.
 * https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
 */
const TOKENS = new Set([
  "on", "off", "name", "honorific-prefix", "given-name", "additional-name", "family-name",
  "honorific-suffix", "nickname", "email", "username", "new-password", "current-password",
  "one-time-code", "organization-title", "organization", "street-address", "address-line1",
  "address-line2", "address-line3", "address-level4", "address-level3", "address-level2",
  "address-level1", "country", "country-name", "postal-code", "tel", "tel-country-code",
  "tel-national", "url",
]);

const RULES = [
  [/first name$/, "given-name"],
  [/last name$/, "family-name"],
  [/^name$/, "name"],
  [/email/, "email"],
  [/password/, "new-password"],
  [/address$/, "street-address"],
  [/^city$/, "address-level2"],
  [/^state$/, "address-level1"],
  [/^zip ?code$/, "postal-code"],
  [/^(phone|phone_number|phone number)$/, "tel-national"],
  [/^country ?code$/i, "tel-country-code"],
  [/^(title|role)$/, "organization-title"],
  [/^prefix$/, "honorific-prefix"],
];

const autocompleteToken = (hint) => {
  if (hint == null || hint === "") return undefined;
  const value = String(hint).trim();
  if (TOKENS.has(value)) return value;
  const rule = RULES.find(([re]) => re.test(value));
  return rule ? rule[1] : "off";
};

export default autocompleteToken;
